import {brandConfigObjectMap} from "@/brand/brandConfig";

export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', getBrandConfig('blg-en'));
brandConfigMap.set('https://fantasy-play-esport-et.migration.penrosesystems.com', getBrandConfig('fantasy-soccer-en'));
brandConfigMap.set('https://blg-play-esport-et.migration.penrosesystems.com', getBrandConfig('blg-en'));

export function getBrandConfig(brand) {
    const brandConfigObject = brandConfigObjectMap.get(brand);
    return {
        brand,
        pricePoint: brandConfigObject.pricePoint,
        offerCode: brandConfigObject.offerCode,
        headerText: brandConfigObject.headerText,
        subHeaderText: brandConfigObject.subHeaderText,
        gameUrl: brandConfigObject.gameUrl,
        errorUrl: brandConfigObject.errorUrl,
        redirectUrl: brandConfigObject.redirectUrl,
        platformUrl: brandConfigObject.platformUrl,
        errorText: brandConfigObject.errorText,
        gtmIdentifier: brandConfigObject.gtmIdentifier,
        tabTitle: brandConfigObject.tabTitle,
        productId: brandConfigObject.productId,
        termsAndConditionsUrl: brandConfigObject.termsAndConditionsUrl,
        campaignId: brandConfigObject.campaignId,
        mcc: brandConfigObject.mcc,
        mnc: brandConfigObject.mnc,
        spId: brandConfigObject.spId,
        serviceId: brandConfigObject.serviceId,
        subscribeButton : brandConfigObject.subscribeButton,
        unsubHelpText : brandConfigObject.unsubHelpText,
        termsAndConditionsText : brandConfigObject.termsAndConditionsText,
        landingPage: brandConfigObject.landingPage,
        battlegroundsLabel: brandConfigObject.battlegroundsLabel,
    }
}
